export default __webpack_public_path__ + "static/media/truck.75a88d88.png";